import { BodySmall, Box } from '@parspec/pixel';
import { CustomNoRowsOverlayProps } from 'ag-grid-react';

export default (props: CustomNoRowsOverlayProps & { noRowsMessageFunc: () => string }) => {
    return (
        <Box>
            <BodySmall>
                {props.noRowsMessageFunc()}
            </BodySmall>
        </Box>
    );
}